import PAbout from "../../images/about.jpg";

const About = () => {
    return (
        <section className="bg-black" id="about">
            <div className="max-w-7xl mx-auto px-4 py-14 sm:py-20">
                <div className="mb-2 sm:mb-5">
                    <h2 className="font-semibold text-white text-4xl md:text-6xl">About <span className="text-primary pridi">Me</span>.</h2>
                </div>
                <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
                    <div className="w-full lg:w-2/3 flex flex-col gap-4">
                        <p className="text-white text-base sm:text-lg">
                            A dedicated software engineer passionate about creating modern, responsive, and scalable applications. Committed to continuous learning, clean code, and delivering meaningful digital experiences.
                        </p>
                        <p className="text-white text-base sm:text-lg">
                            Based in Kediri, Indonesia, I combine this technical expertise with a strong obsession for design. I've shipped products for startups, scale-ups, and solo founders who want software that's both functional and beautiful.
                        </p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                            <div className="border border-white/20 text-white py-3 px-4 sm:px-6">
                                <p className="text-xs text-white/50">Location</p>
                                <p className="text-lg text-white">Kediri, Indonesia</p>
                            </div>
                            <div className="border border-white/20 text-white py-3 px-4 sm:px-6">
                                <p className="text-xs text-white/50">Focus</p>
                                <p className="text-lg text-white">Software Engineer</p>
                            </div>
                            <div className="border border-white/20 text-white py-3 px-4 sm:px-6">
                                <p className="text-xs text-white/50">Education</p>
                                <p className="text-lg text-white">Bachelor Degree</p>
                            </div>
                            <div className="border border-white/20 text-white py-3 px-4 sm:px-6">
                                <p className="text-xs text-white/50">Major</p>
                                <p className="text-lg text-white">Informatic Engineering</p>
                            </div>
                        </div>
                    </div>
                    <div className="relative hidden md:flex flex-col items-center lg:items-start shrink-0">
                        <div className="border-2 border-primary overflow-hidden">
                            <img
                                src={PAbout}
                                loading="lazy"
                                alt="Deva, software engineer"
                                className="w-full sm:w-96 object-cover"
                            />
                        </div>
                        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 lg:left-auto lg:translate-x-0 lg:right-0 border-2 border-black px-6 py-4 text-sm bg-primary text-white font-bold">
                            Deva Rahma Nugroho<br />
                            <span className="text-white/70">Software Engineer</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
